(function(){
"use strict";

const fmt = n => "$" + n.toLocaleString("es-CL");
// Precios copiados de Kaching el 16-10 (en la versión final salen de Kaching o de metacampos)
const PACKS = [
  {id:"p1", name:"1 frasco", short:"1 frasco", days:30, perDay:663, price:19900, was:null, free:false},
  {id:"p3", name:"3 frascos", short:"3 frascos", days:90, perDay:539, price:48479, was:59700, free:true, tag:"Más vendido", hab:"90 días de hábito"},
  {id:"p6", name:"6 frascos", short:"6 frascos", days:180, perDay:496, price:89364, was:119400, free:true, tag:null}
];
const pk = id => PACKS.find(x => x.id === id);
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const buyEl = () => document.querySelector("kaching-bundle") || document.querySelector(".product-form") || document.querySelector(".product__info-container");
const go = () => { const b = buyEl(); if (b) b.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"}); };
function pickK(id){
  const i = {p1:0, p3:1, p6:2}[id];
  const bars = [...document.querySelectorAll("kaching-bundle .kaching-bundles__bar")].filter(b => !b.classList.contains("kaching-bundles__checkbox-upsells__upsell"));
  if (bars[i]) bars[i].click();
  go();
}
function render(){
  document.querySelectorAll("[data-strip]").forEach(el => {
    el.innerHTML = PACKS.map(p => `<button class="spt" role="radio" aria-checked="false" data-id="${p.id}">
      ${p.tag ? `<span class="tg">${p.tag}</span>` : ""}
      <b>${p.name}</b><span class="pr num">${fmt(p.price)}</span><span class="pd num">${fmt(p.perDay)} al día</span>${p.hab ? `<span class="hb">${p.hab}</span>` : ""}
      <span class="sh">${p.free ? "Despacho gratis" : "Despacho aparte"}</span></button>`).join("");
  });
  const sr = document.getElementById("sRows");
  if (sr) sr.innerHTML = [pk("p3"), pk("p6")].map(r => `<span class="s-row ${r.id==="p3" ? "hi" : ""}"><span class="n">${r.short}</span><b class="num">${fmt(r.perDay)}/día</b><span class="num">${fmt(r.price)}</span></span>`).join("");
}
document.addEventListener("click", e => {
  const sb = e.target.closest(".lp .spt"); if (sb) { pickK(sb.dataset.id); return; }
  const dp = e.target.closest(".lp [data-pick]"); if (dp) { pickK(dp.dataset.pick); return; }
  if (e.target.closest("#sBtn")) go();
});
render();
// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  // Feriados irrenunciables (Ley 19.973): ese día no hay despacho, pasa al día siguiente
  const FER = ["2026-01-01","2026-05-01","2026-09-18","2026-09-19","2026-12-25","2027-01-01","2027-05-01","2027-09-18","2027-09-19","2027-12-25"];
  const ymd = x => x.getFullYear() + "-" + String(x.getMonth() + 1).padStart(2, "0") + "-" + String(x.getDate()).padStart(2, "0");
  let k = h >= 12 ? 1 : 0;
  d.setDate(d.getDate() + k);
  while (FER.includes(ymd(d))) { d.setDate(d.getDate() + 1); k++; }
  const txt = `Llega ${k === 0 ? "hoy" : k === 1 ? "mañana" : "el"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Resultados: el detalle se abre bajo la fila del ícono tocado
const IC = {
  face:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="#1A1B18" stroke-width="2"/><circle cx="9" cy="10.5" r="1.1" fill="#1A1B18"/><circle cx="15" cy="10.5" r="1.1" fill="#1A1B18"/><path d="M8.5 14.5c1.9 1.9 5.1 1.9 7 0" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round"/>',
  hair:'<path d="M6 21c0-7 1-12 6-15 5 3 6 8 6 15M9.5 21c0-5 .8-8.5 2.5-10.5 1.7 2 2.5 5.5 2.5 10.5" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  bone:'<path d="M8.5 4.5a2.6 2.6 0 0 0-3.9 3.1 2.6 2.6 0 1 0 2.6 4.1l5.1 5.1a2.6 2.6 0 1 0 4.1 2.6 2.6 2.6 0 1 0 3.1-3.9 2.6 2.6 0 0 0-3.2-1.2l-5.1-5.1a2.6 2.6 0 0 0-2.7-4.7z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/>',
  cup:'<path d="M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM16 10.5h1.5a2.5 2.5 0 0 1 0 5H16M8 3.5c0 1.5 1 1.5 1 3M12 3.5c0 1.5 1 1.5 1 3" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
};
const OUT = [
  {ic:"face", area:"Piel", pain:"En la firmeza de tu piel.", win:"Lo que tu piel usa para mantenerse firme", body:"El colágeno es la proteína principal de la dermis: le da firmeza y elasticidad. Tomarlo a diario contribuye a mantenerla. Cada scoop trae 10 g de colágeno tipo I, el mismo de tu piel.", d:[["Colágeno","10 g"],["Tipo","I"]]},
  {ic:"hair", area:"Pelo y uñas", pain:"En uñas y pelo.", win:"Materia prima para pelo y uñas", body:"Los péptidos de colágeno aportan los aminoácidos que tu cuerpo usa para formar estas estructuras (glicina y prolina). Tomándolo todos los días, contribuyen a su cuidado diario.", d:[["Colágeno","10 g"],["Tipo","I"]], q:["Buen producto, llevo casi 3 semanas de uso y ya noto menos caída del pelo, mis uñas más fuertes y menor dolor de articulaciones.","Alejandra H.A."]},
  {ic:"bone", area:"Articulaciones y huesos", pain:"En rodillas, manos y espalda.", win:"Colágeno donde tu cuerpo más lo usa", body:"El colágeno tipo I es parte de huesos, tendones y ligamentos. La proteína contribuye a mantener los huesos en condiciones normales.", d:[["Colágeno","10 g"],["Proteína","9,3 g"]], q:["Aún no completo el mes con este maravilloso producto, pero ya siento más fuertes mis articulaciones. De su sabor, muy bien: lo tomo mezclado con café y queda muy rico.","Nelson O."]},
  {ic:"cup", area:"Proteína", pain:"En tu café de la mañana.", win:"9,3 g de proteína sin cambiar tu café", body:"Un scoop suma 9,3 g de proteína a tu café, sin cambiarle el sabor. La proteína contribuye a conservar la masa muscular.", d:[["Proteína","9,3 g"],["Azúcar","0 g"]]}
];
let oi = 0;
const og = document.getElementById("og");
const wide = matchMedia("(min-width: 720px)");
function renderOut(){
  if (!og) return;
  const tiles = OUT.map((o,i) => `<button class="ot" aria-expanded="${i===oi}" aria-controls="od" data-i="${i}">
      <span class="top"><span class="ic"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">${IC[o.ic]}</svg></span><span class="chev" aria-hidden="true">▾</span></span>
      <b>${o.area}</b><span class="p">${o.pain}</span></button>`);
  tiles.push(`<button class="ot cta" data-pick="p3"><b>Todo esto en un scoop</b><span class="p">Desde $496 al día →</span></button>`);
  let html = "";
  const per = wide.matches ? 4 : 2;
  for (let r = 0; r < tiles.length; r += per) {
    html += tiles.slice(r, r + per).join("");
    if (oi >= 0 && Math.floor(oi/per) === r/per) {
      const o = OUT[oi];
      html += `<div class="od" id="od" role="region" aria-label="${o.area}"><p class="label">${o.area}</p><p class="win">${o.win}</p><p>${o.body}</p><div class="doses">${o.d.map(x=>`<span class="dose">${x[0]} <b>${x[1]}</b></span>`).join("")}</div>${o.q ? `<q>"${o.q[0]}"<cite>${o.q[1]} <span class="cv">✓ Compra verificada</span></cite></q>` : ""}</div>`;
    }
  }
  og.innerHTML = html;
}
if (og) og.addEventListener("click", e => {
  const b = e.target.closest(".ot:not(.cta)"); if (!b) return;
  const i = +b.dataset.i; oi = (oi === i) ? -1 : i; renderOut();
  og.querySelector(`[data-i="${i}"]`).focus();
});
renderOut();
wide.addEventListener("change", renderOut);

// Etiqueta
const lm = document.getElementById("labelModal"); let lastFocus = null;
if (lm) {
  document.querySelectorAll("[data-label]").forEach(b => b.addEventListener("click", () => { lastFocus = b; lm.hidden = false; document.getElementById("labelClose").focus(); }));
  const closeLm = () => { lm.hidden = true; if (lastFocus) lastFocus.focus(); };
  document.getElementById("labelClose").addEventListener("click", closeLm);
  lm.addEventListener("click", e => { if (e.target === lm) closeLm(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !lm.hidden) closeLm(); });
}
if (reduce) document.querySelectorAll(".lp video").forEach(v => { v.removeAttribute("autoplay"); v.pause(); });

// Barra fija: aparece solo cuando no hay otra compra a la vista (sin ruido de botones)
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  const zones = () => [document.querySelector(".product__info-container"), document.querySelector(".lp-galeria"), ...document.querySelectorAll(".lp .strip"), document.querySelector(".lp .final")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("video").forEach(v => { const im = document.createElement("img"); im.className = "vposter"; im.src = (s.querySelector("video") || {}).poster || ""; im.alt = ""; v.replaceWith(im); });
    c.querySelectorAll("button,[data-label]").forEach(x => { x.removeAttribute("data-label"); x.setAttribute("tabindex", "-1"); });
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

})();
